import React from 'react';
import Styles from './styled';
import FileTextIcon from '../Icons/FileText';
import ButtonLink from '../ButtonLink';
import noop from '../../../util/noop';
import { getBaseExpressAppUrl } from '../../../util/config';

const Component = ({ onSignin = noop, className = '' }) => (
  <Styles>
    <h2 className='type-h4'>Free Documents</h2>
    <p className='type-caption'>
      These forms can be accessed for free by signing in to your account
    </p>
    <ul className='links'>
      <li className='link'>
        <p>
          <FileTextIcon /> 1098 Tax Form
        </p>
      </li>
      <li className='link'>
        <p>
          <FileTextIcon /> Payoff Quote
        </p>
      </li>
    </ul>
    <ButtonLink
      to={getBaseExpressAppUrl() + '/portal/login'}
      isExternal
      newTab
      appearance='dark'
      outline
      onClick={onSignin}
      className={className}
    >
      Sign in
    </ButtonLink>
  </Styles>
);

Component.propTypes = {};

export default Component;
